import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortDown } from '@fortawesome/free-solid-svg-icons';

import { set_go_to_page, set_lang } from "../../../actions";

import './header.scss';

library.add(faSortDown);

class Header extends PureComponent {
    constructor(props) {
        super(props);
        const { userMenu } = props;

        let lang = userMenu.find(el => el.lang === props.language);

        this.state = {
            menu: lang,
            lang: props.language,
        };

        props.goToPage(0);
        window.addEventListener('resize', this.changeSize);
    }

    changeSize = () => {
        if (window.innerWidth > 680 ) this.closeMenu();
    };

    closeMenu = () => {
        let navBar = document.querySelector('#navbar');
        document.querySelector('#icon').classList.remove('openedIcon');
        navBar.classList.remove('openedNavBar');
        [...navBar.querySelectorAll('div')].forEach(el => el.classList.remove('openDiv'));
        document.querySelector('#containerInner').classList.remove('openMenuCont');
        document.querySelector('#container').classList.remove('openContainer');
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.changeSize);
    }

    changeLanguage = e => {
        const { setLang, userMenu, setLanguage } = this.props;

        let lang = e.target.id;
        let newLanguage = userMenu.find(el => el.lang === lang);

        this.setState({
            menu: newLanguage,
            lang: newLanguage.lang,
        }, () => {
            setLanguage(this.state.lang);
            setLang(this.state.lang);
        })
    };

    openMenu = el => {
        let elem = el.target;
        let navBar = elem.nextSibling;

        elem.classList.toggle('openedIcon');
        el.target.classList.toggle('close');
        navBar.classList.toggle('openedNavBar');

        [...navBar.querySelectorAll('div')].forEach(el => el.classList.toggle('openDiv'));

        // document.querySelector('#containerInner').classList.toggle('openMenuCont');
        // document.querySelector('#container').classList.toggle('openContainer');
    };

    render() {
        const { menu: { menuList, languages }, lang } = this.state;
        const { active, goToPage } = this.props;

        const keys = Object.keys(languages);
        const className = lang === 'arm' ? 'arm' : 'ru';

        return (
            <div id="header">
                <div>
                    <nav>
                        <div id={"icon"} onClick={this.openMenu} />
                        <div id={"navbar"} className={className}>
                            {Object.values(menuList).map((el, index) => {
                                let activeClass = index === active ? 'active' : '';
                                return (
                                    <div onClick={() => goToPage(0)}>
                                        <Link
                                            className={activeClass}
                                            to={index === 0 ? '/' : '/' + Object.keys(menuList)[index]}
                                        >
                                            {el.toUpperCase()}
                                        </Link>
                                    </div>
                                )
                            })
                            }
                        </div>
                        <div id={'lang'}>
                            {Object.values(languages || {}).map((el, index) => (
                                <div
                                    key={keys[index]}
                                    id={keys[index]} 
                                    className={languages[lang] === el ? 'selected' : ''}
                                    onClick={this.changeLanguage}>
                                    {el.toUpperCase()}
                                </div>
                            ))}
                        </div>
                    </nav>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ main: { width } }) => ({
    width
});

const mapDispatchToProps = dispatch => ({
    setLang: lang => dispatch(set_lang(lang)),
    goToPage: page => dispatch(set_go_to_page(page)),
});

export default connect(mapDispatchToProps, mapDispatchToProps)(Header);
